import React, { useState, useEffect } from 'react';
import { SwitchContainer, Container, Slider } from './styles';

export type SwitchProps = {
    checked?: boolean;
    className?: string;
    label?: string;
    labelContents?: React.ReactNode[];
    handleChangeCallback?: (value: boolean) => void;
}

export const Switch = ({
    checked = false,
    label,
    className = '',
    labelContents,
    handleChangeCallback
}: SwitchProps) => {

    const [isChecked, setIsChecked] = useState(checked);

    useEffect(() => {
        if (isChecked !== isChecked) {
            setIsChecked(checked);
        }
    }, [checked]);

    const onChange = () => {
        setIsChecked(!isChecked);
        handleChangeCallback && handleChangeCallback(!isChecked);
    }

    return (
        <Container className={className}>
            <SwitchContainer>
                <input type="checkbox" checked={isChecked} onClick={onChange} />
                <Slider className="slider round" backgroundChecked={isChecked} />
            </SwitchContainer>
            { 
                label ? (
                    <label> { label } </label>
                ) : (
                    <label> { labelContents.map((label: React.ReactNode) => label) } </label>
                )
            }
        </Container>
    )
}